import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs as fallbackFaqs } from "../mock";
import { useContent, renderHighlightedTitle } from "../lib/useContent";

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const { field } = useContent("home");
  const pretitle = field("faq_home", "pretitle", "Domande frequenti");
  const headline = field("faq_home", "headline", "Tutto quello che vuoi sapere sul CCN.");
  const highlightTerms = field("faq_home", "highlight_terms", ["CCN"]);
  const description = field("faq_home", "description", "Non trovi la tua risposta? Scrivici, ti risponderemo entro un giorno lavorativo.");
  const itemsRaw = field("faq_home", "items", null);
  const faqs = Array.isArray(itemsRaw) && itemsRaw.length
    ? itemsRaw.filter((it) => it.visible !== false)
    : fallbackFaqs;

  if (faqs.length === 0) return null;

  return (
    <section className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            {pretitle !== "" && <div className="text-xs uppercase tracking-[0.22em] text-stone-500 mb-4">{pretitle}</div>}
            <h2 className="font-display text-4xl md:text-5xl leading-tight text-stone-950">
              {renderHighlightedTitle(headline, highlightTerms)}
            </h2>
            {description !== "" && <p className="text-stone-600 mt-6">{description}</p>}
          </div>
          <div className="lg:col-span-8">
            <div className="border-t border-stone-200">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={`${f.q}-${i}`} className="border-b border-stone-200">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between text-left py-7 group"
                    >
                      <span className="font-display text-xl md:text-2xl text-stone-950 pr-6 group-hover:text-[#12964A] transition-colors">
                        {f.q}
                      </span>
                      <span className={`w-10 h-10 rounded-full flex items-center justify-center border transition-all ${isOpen ? "bg-[#12964A] border-[#12964A] text-white rotate-180" : "border-stone-300 text-stone-700"}`}>
                        {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                      </span>
                    </button>
                    <div className={`grid transition-all duration-500 ${isOpen ? "grid-rows-[1fr] pb-7" : "grid-rows-[0fr]"}`}>
                      <div className="overflow-hidden">
                        <p className="text-stone-600 text-lg leading-relaxed max-w-2xl">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
